$(function () {
  var $searchTrigger = $('form.search input, #menu-trigger')
  var $searchCloseTrigger = $('.search_overlay .search_close_trigger')
  var $searchOverlay = $('.search_overlay')
  var paddingTop = 48 - (parseInt($('header .top').css('padding-top')))

  $('.search_overlay #query').on('keyup', (e) => {
    // console.log(e.keyCode);
    if (e.keyCode === 27) {
      e.preventDefault()
      e.stopPropagation()
      $searchOverlay.animate({scrollTop: 0}, 1)
      if (!$('.menu_overlay').is(':visible')) {
        $('body').removeClass('menuOpen')
      }
      $searchOverlay.fadeOut('slow')
      $searchOverlay.off('click', removeSearch)
    }
  });

  $searchTrigger.on('click', function (e) {
    e.preventDefault();

    $('body').addClass('menuOpen');

    if ($('#homepagesearch').length > 0) {
      var $parenform = $searchTrigger.parents('.middle');
      var offset = parseInt($('#homepagesearch form.search').offset().top - $(window).scrollTop());

      var scrollTo = (300 - paddingTop) + (306 - offset)
      $parenform.css('top', scrollTo + 'px');
    }

    $searchOverlay.fadeIn('slow', function (e) {
      $('.search_overlay #query').focus();
      $searchOverlay.on('click', removeSearch);

      if ($('#homepagesearch').length > 0) {
        $parenform.css('top', '306px');
      }
    });

  });

  $('.search_trigger').on('click', function (e) {
    e.preventDefault()
    $('body').addClass('menuOpen')
    $searchOverlay.fadeIn('slow', function (e) {
      $('.search_overlay #query').focus()
      $searchOverlay.on('click', removeSearch)
    })
  })

  $searchCloseTrigger.on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()
    $searchOverlay.animate({scrollTop: 0}, 1)
    if (!$('.menu_overlay').is(':visible')) {
      $('body').removeClass('menuOpen')
    }
    $searchOverlay.fadeOut('slow')
    $searchOverlay.off('click', removeSearch)
  })

  function removeSearch (e) {
    if (!$(e.target).is('.search_overlay_inner div[class^="col"] *')) {
      $searchOverlay.animate({scrollTop: 0}, 1)
      if (!$('.menu_overlay').is(':visible')) {
        $('body').removeClass('menuOpen')
      }
      $searchOverlay.fadeOut('slow')
      $searchOverlay.off('click', removeSearch)
    }
  }


  // $(function(){
  //
  //   $(".search_overlay_inner form.searchover input.searchresultinput").keyup(function(){
  //
  //     // var val = $(this).val().trim();
  //     // val = val.replace(/\s+/g, '');
  //     if( this.value.length < 3 ) return;
  //
  //       console.log('3 or more');
  //       $.ajax({
  //         url: 'https://wood-search01.squiz.co.uk/s/suggest.json?collection=woodMeta&fmt=json%2B%2B&alpha=0.5&profile=_default&partial_query=pag',
  //         success: function (result) {
  //           console.log(result);
  //         }
  //       })
  //
  //
  //   });
  // });
})